import './styles.scss'

import { DrawerState, ExpandableDrawer } from '../expandable-drawer'
import { useCallback, useState } from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import { useSelector } from 'react-redux'
import { RootState } from '@AppState/redux-store.ts'
import { dynamicTemplate } from '@Util/dynamic-template.ts'

const CLASS_NAME = 'gby-k2g-welcome-drawer'

export type WelcomeDrawerProps = {
  currentDrawNumber: number
  onOpenChange: (open: boolean) => void
}

export const WelcomeDrawer = (props: WelcomeDrawerProps) => {
  const hostConfig = useSelector((state: RootState) => state.hostConfig)
  const [drawerState, setDrawerState] = useState<DrawerState>(DrawerState.OPEN)

  const drawerOpenChangeHandler = useCallback(
    (open: boolean) => {
      setDrawerState(open ? DrawerState.OPEN : DrawerState.CLOSED)
      props.onOpenChange(open)
    },
    [props],
  )

  const bodyTemplate = useCallback(() => {
    return dynamicTemplate(hostConfig.config?.content.welcomeDrawer.bodyTemplate, {
      currentDrawNumber: props.currentDrawNumber,
    })
  }, [hostConfig.config?.content.welcomeDrawer.bodyTemplate, props.currentDrawNumber])

  return (
    <Dialog.Root open={drawerState === DrawerState.OPEN} onOpenChange={drawerOpenChangeHandler}>
      <Dialog.Description>
        {' '}
        You’ve jumped in during an active draw {props.currentDrawNumber}! Sit tight and watch as the
        numbers roll in—good luck!
      </Dialog.Description>

      <ExpandableDrawer
        classPrefix={CLASS_NAME}
        hasCloseButton={true}
        scrollable={false}
        state={drawerState}
        onOpenChange={() => {}}
        onOpenAutoFocus={() => {}}>
        <div className={CLASS_NAME}>
          <div className={`${CLASS_NAME}__title`}>
            {hostConfig.config?.content.welcomeDrawer.title}
          </div>
          <img
            className={`${CLASS_NAME}__icon`}
            src={hostConfig.config?.content.welcomeDrawer.imageUrl}
            alt={hostConfig.config?.content.welcomeDrawer.imageUrl}></img>
          <div dangerouslySetInnerHTML={{ __html: bodyTemplate() }}></div>
        </div>
      </ExpandableDrawer>
    </Dialog.Root>
  )
}
